import { useState, useEffect, useRef } from "react";
import _ from "lodash";
import Arrow from "../../../../../../assets/images/Inner/arrow.svg";
import "./AverageAmericanSpend.scss";
import {
     COSTS_BENCHMARK,
} from "../../../../../../utils/constants";

// 
function AverageAmericanSpend(args) {
    
     //
     const [isExpanded, setIsExpanded] = useState(false);

     // 
     return (
          <div className="mb-3 average-american-spend">

               {/* title */}
               <div className="average-american-spend-title" onClick={() => setIsExpanded(!isExpanded)}>
                    <div>
                         Average monthly expense of Americans 
                    </div>
                    <div style={{}}>
                         {isExpanded?
                         <img src={Arrow} className=""/>
                         :
                         <img src={Arrow} className="" style={{transform: "rotate(180deg)"}}/>
                         }
                    </div>
               </div>

               {/* table */}
               {isExpanded?
                    <div className="avgspend-table">
                         {_.map(COSTS_BENCHMARK, (value, key) => {
                              if (key == "isManualCost") { return null; }
                              return (
                                   <div className="avgspend-element" style={{order: key=="other"?  99 : null}}>
                                        <div className="avgspend-label">
                                             {key}
                                        </div>
                                        <div className="avgspend-value">
                                             ${value}
                                        </div>
                                   </div>
                              );
                         })}
                    </div>
                    : null
               }
          </div>
     );
    
}


export default AverageAmericanSpend;
